import "./app/publicPath"

const Vue = window.Vue

Vue.component("OneStepCheckout", () => import("./app/components/OneStepCheckout.vue"))
Vue.component("ValidationWrapper", () => import("./app/components/ValidationWrapper.vue"))
